export default "__VITE_ASSET__CRxJKv47__"